import React, { useEffect, useState } from "react";
import DataOverview from "../components/data/DataOverview";
import { useLocation, useMatch } from "react-router-dom";
import Loader from "../components/layouts/Loader";
import { getList } from "../client/actions/apiActions";
import { connect } from "react-redux";

const tableName = "config";
const editPathName = "/settings/config/:id";
const tableColumns = [
  {
    dataField: "id",
    sort: true,
  },
];
const defaultFieldData = [
  {
    displayName: "SMTP Settings",
    fieldName: "titleSMTPSettings",
    fieldType: "title",
    colSize: 1,
    required: false,
    requiredMessage: "",
  },
  {
    displayName: "SMTP Email Host",
    fieldName: "smtpEmailHost",
    fieldType: "text",
    colSize: 3,
    required: false,
    requiredMessage: "",
  },
  {
    displayName: "SMTP From Email",
    fieldName: "smtpFromEmail",
    fieldType: "text",
    colSize: 3,
    required: false,
    requiredMessage: "",
  },
  {
    displayName: "SMTP From Password",
    fieldName: "smtpFromPassword",
    fieldType: "text",
    colSize: 3,
    required: false,
    requiredMessage: "",
  },
  {
    displayName: "SMTP From Name",
    fieldName: "smtpFromName",
    fieldType: "text",
    colSize: 3,
    required: false,
    requiredMessage: "",
  },
  {
    displayName: "SMTP Port",
    fieldName: "smtpPort",
    fieldType: "text",
    colSize: 3,
    required: false,
    requiredMessage: "",
  },
  {
    displayName: "Test Email Template",
    fieldName: "testTemplate",
    fieldType: "dropdown",
    colSize: 3,
    required: false,
    requiredMessage: "Page Title",
  },
];
const fieldDataDefault = {
  pageUrl: "",
  pageTitle: "",
  pageHTML: "",
};

const Config = (props) => {
  const location = useLocation();
  const match = useMatch(editPathName);
  const [loading, setLoading] = useState(true);
  const [fieldData, setFieldData] = useState(defaultFieldData);
  let parentRoute = location.pathname;

  useEffect(() => {
    props.getList("emailTemplates");
    setLoading(false);
  }, []);

  useEffect(() => {
    if (props.data.tableName === "emailTemplates") {
      let tmpData = fieldData;
      tmpData.map((data, index) => {
        if (data.fieldName === "testTemplate") {
          tmpData[index].dropdownData = props.data.emailTemplates;
        }
      });
      setFieldData(tmpData);
    }
  }, [props.data]);

  if (match) {
    parentRoute = match.pattern.path.replace("/:id", "");
  }

  if (loading) return <Loader />;
  return (
    <DataOverview
      id={1}
      tableName={tableName}
      pageMode={"edit"}
      savePageMode={"edit"}
      singleEdit={true}
      settings={{ showClone: false }}
      route={location.pathname}
      parentRoute={parentRoute}
      pageTitle={"Config"}
      listTitle={"Config"}
      listSubTitle={""}
      addTitle={""}
      addSubTitle={""}
      editTitle={"Edit Config"}
      editSubTitle={""}
      tableColumns={tableColumns}
      fieldData={fieldData}
      fieldDataDefault={fieldDataDefault}
    />
  );
};

const mapStateToProps = (state) => ({
  data: state.pages.data,
});

export default connect(mapStateToProps, { getList })(Config);
